import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconUploadStyle0 = gravityIconIndividualCss;

const GravityIconUpload = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '537efaf37821a2e51abf985bf3540e1ca78dcfec', color: this.color, size: this.size }, h("svg", { key: '8f949cfcf7d4b8cdcecd08ccc6e67ac24f6533cf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'f5456478a36bd40540061d687732b63d1cf40ebe', d: "M10.29 9H7a.41.41 0 0 1-.29-.69l4-4a.42.42 0 0 1 .57 0l4 4A.41.41 0 0 1 15 9h-3.21v5.5a.51.51 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9ZM5.5 17.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
};
GravityIconUpload.style = GravityIconUploadStyle0;

export { GravityIconUpload as gravity_icon_upload };

//# sourceMappingURL=gravity-icon-upload.entry.js.map